export default [
  {
    path: '/account',
    name: 'account',
    components: {
      default: () => import('@/views/Account/Account.vue'),
      appbar: () => import('@/components/appbars/AppBarDesktop.vue'),
      sidebar: () => import('@/views/Account/components/AccountNav.vue'),
      footer: () => import('@/components/AppFooter.vue'),
    },
    meta: {
      requiresAuth: true,
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
      appBottomNav: {
        order: 0,
      },
      sidebarVisibility(app) {
        return app.display.smAndDown.value
      },
    },
    children: [
      // security
      {
        path: 'settings/security',
        name: 'security settings',
        component: () => import(
          '@/views/Account/Settings/Security.vue'
        ),
      },
      {
        path: 'settings/security/connections',
        component: () => import(
          '@/views/Account/Settings/Connections.vue'
        ),
      },
      {
        path: 'settings/security/sessions',
        component: () => import(
          '@/views/Account/Settings/AuthSessions.vue'
        ),
      },
      {
        path: 'settings/security/mfa/setup',
        component: () => import(
          '@/views/Account/Settings/mfa/setup.vue'
        ),
      },
      {
        path: 'settings/security/mfa/confirm',
        component: () => import(
          '@/views/Account/Settings/mfa/confirm.vue'
        ),
      },
      {
        path: 'settings/security/mfa/remove',
        component: () => import(
          '@/views/Account/Settings/mfa/remove.vue'
        ),
      },
      // privacy
      {
        path: 'settings/privacy',
        name: 'privacy settings',
        component: () => import(
          '@/views/Account/Settings/Privacy.vue'
        ),
      },
      {
        path: 'settings/privacy/logs',
        component: () => import(
          '@/views/Account/Settings/ActivityLog.vue'
        ),
      },
      {
        path: 'settings/privacy/reset',
        component: () => import(
          '@/views/Account/Settings/Reset.vue'
        ),
      },
      {
        path: 'settings/privacy/delete',
        component: () => import(
          '@/views/Account/Settings/Delete.vue'
        ),
      },
      {
        path: 'settings/privacy/export',
        component: () => import(
          '@/views/Account/Settings/Export/Export.vue'
        ),
      },
      {
        path: 'settings/privacy/export/confirm',
        component: () => import(
          '@/views/Account/Settings/Export/Confirm.vue'
        ),
      },
      {
        path: 'settings/privacy/import',
        component: () => import(
          '@/views/Account/Settings/Import/Import.vue'
        ),
      },
      {
        path: 'settings/privacy/import/confirm',
        component: () => import(
          '@/views/Account/Settings/Import/Confirm.vue'
        ),
      },
      {
        path: 'settings/app',
        name: 'app settings',
        component: () => import(
          '@/views/Account/Settings/App.vue'
        ),
      },
      {
        path: 'settings/newsletter',
        name: 'newsletter settings',
        component: () => import(
          '@/views/Account/Settings/Newsletter.vue'
        ),
      },
      // legal
      {
        path: 'legal/imprint',
        name: 'imprint',
        component: () => import(
          '@/views/Account/Legal/Imprint.vue'
        ),
      },
      {
        path: 'legal/tos',
        name: 'terms of service',
        component: () => import(
          '@/views/Account/Legal/TermsOfService.vue'
        ),
      },
      {
        path: 'legal/privacy',
        name: 'privacy',
        component: () => import(
          '@/views/Account/Legal/PrivacyPolicy.vue'
        ),
      },
      {
        path: 'legal/licenses',
        name: 'licenses',
        component: () => import(
          '@/views/Account/Legal/Licenses.vue'
        ),
      },
    ],
  },
  {
    path: '/email/confirm',
    component: () => import(
      '@/views/Account/EmailConfirm.vue'
    ),
    meta: {
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
]
